// Add units
export const REGISTER_PARTICIPANT_LIST = "REGISTER_PARTICIPANT_LIST";
export const REGISTER_PARTICIPANT_LIST_SUCCESS = "REGISTER_PARTICIPANT_LIST_SUCCESS";
export const REGISTER_PARTICIPANT_LIST_FAIL = "REGISTER_PARTICIPANT_LIST_FAIL";